import { CsvPatchLeadMappingEnum as DP_FIELDS } from '@/apis/generated/dialbunny';
import { BaseFieldMapperUtil } from '@/shared/utils/base-field-mapper-util';
import type {
  BaseField,
  BaseFieldMap,
  BaseCustomFieldMap,
} from '@/shared/utils/base-field-mapper-util';
import logger from '@/logger';

const log = logger.getChild('csv-field-mapper-util');

export type Field = BaseField<DP_FIELDS>;

const DP_FIELDS_VALUES_SET = new Set<string>(Object.values(DP_FIELDS));

export type CsvDPFieldMap = BaseFieldMap<DP_FIELDS>;
export type CsvCustomFieldMap = BaseCustomFieldMap;

export class CsvFieldMapperUtil extends BaseFieldMapperUtil<DP_FIELDS> {
  readonly requiredFields: DP_FIELDS[] = [
    DP_FIELDS.FirstName,
    DP_FIELDS.LastName,
    DP_FIELDS.PrimaryPhone,
  ];
  readonly fieldsValuesSet = DP_FIELDS_VALUES_SET;

  protected getLoggerName(): string {
    return 'csv-field-mapper-util';
  }

  protected fillWithoutMap(fields: string[], examples: string[]): void {
    log.debug('Filling without map', { fields, examples });
    for (let i = 0; i < fields.length; i++) {
      this.fields.value.push({
        original: fields[i],
        example: examples[i],
        dialpad: this.requiredFields[i] ?? null,
      });
    }
  }

  protected performCustomValidation(
    index: number,
    newValue: DP_FIELDS | null | string,
  ): void {
    if (
      (newValue !== null &&
        (this.requiredFields as string[]).includes(newValue)) ||
      index <= this.requiredFields.length - 1
    ) {
      throw new Error('Cannot change required dialpad fields');
    }
  }

  protected getDoNotImportValue(): DP_FIELDS {
    return DP_FIELDS.DoNotImport;
  }

  validate(): boolean {
    log.debug('Validating fields');
    if (this.fields.value.length === 0) return false;
    for (const field of this.fields.value) {
      if (field.dialpad === null) return false;
    }
    log.debug('Valid');
    return true;
  }
}
